/* RESPONSIBLE TEAM: team-phone */
import type TriggerPhoneReusableWorkflow from 'embercom/models/operator/visual-builder/step/trigger-phone-reusable-workflow';
import StepConfig, { type StepConfigParams } from '../step';

export default class TriggerPhoneReusableWorkflowConfiguration extends StepConfig {
  declare step: TriggerPhoneReusableWorkflow;

  constructor(params: Omit<StepConfigParams, 'component'>) {
    super({
      component:
        'workflows/graph-editor/node-items/steps/trigger-phone-reusable-workflow-component',
      ...params,
    });
  }
}
